export default __webpack_public_path__ + "static/media/rec-plus.944035cc.svg";